import React, { ReactElement } from 'react';
import { NextPageWithLayout } from 'next';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/about-us.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';
import Markdown from '../components/Markdown';

const AboutUsPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="about-us"
      passHref
    >
      {intl.formatMessage(messages['info.about'])}
    </LinkAndAnchor>,
  ];
  return (
    <>
      <Head
        title={intl.formatMessage(messages['info.about'])}
        description={intl.formatMessage(messages['info.about'])}
      />
      <StaticPageComponent
        breadcrumbs={breadcrumbs}
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages['info.about'])}
      />
    </>
  );
};

AboutUsPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default AboutUsPage;
